import { render, staticRenderFns } from "./SelectAllObjectsButton.vue?vue&type=template&id=23c96206&scoped=true"
import script from "./SelectAllObjectsButton.vue?vue&type=script&lang=js"
export * from "./SelectAllObjectsButton.vue?vue&type=script&lang=js"
import style0 from "./SelectAllObjectsButton.vue?vue&type=style&index=0&id=23c96206&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c96206",
  null
  
)

export default component.exports